import {eq} from '@shared/helpers/lang'

import {getChargePointBalanceBenefit, getPaymoneyAndRewardBenefit} from '@web/actions/pointPayment'
import {
    APIStatus,
    MAXIMUM_LIMIT_CHARGE_POINT_FOR_RESTRICTED_USER,
    PAYMONEY_RESULT_TYPE,
    PayMoneyUserStatus,
    RechargePointLimitType,
} from '@web/core/constants'
import {convertPaymoneyUserStatusType} from '@web/helpers/policies'
import {getChargeableAmtByExceptionType, PaymoneyDisplayBankNameMap} from '@web/slices/chargePoint/slice'
import makeSlice from '@web/slices/chargePoint/sliceMaker'

import {initPaymentMethodManagement} from '../../actions'

const eqResultSuccess = eq(PAYMONEY_RESULT_TYPE.SUCCESS)

const slice = makeSlice({
    extraReducers(builder) {
        builder
            .addCase(initPaymentMethodManagement.fulfilled, (state, {payload}) => {
                const {
                    response: {
                        paymoneyAndPointResult: {
                            paymoney: {availableAmount, balanceAmount, resultType},
                        },
                        chargePointLimitResult: {resultType: chargePointLimitResultType, chargeLimitByType},
                        memberInfoResult: {
                            version,
                            resultType: memberInfoResultType,
                            account,
                            adult,
                            isAMLTarget,
                            currMemberType,
                        },
                        expectedAccumulateRate: {adminAcmRate, bankbookAcmRate, moneyAcmRate},
                    },
                } = payload

                const fetchPaymoneySucceed = eqResultSuccess(resultType)
                const fetchChargePointLimitSucceed = eqResultSuccess(chargePointLimitResultType)

                if (fetchPaymoneySucceed) {
                    state.actualAmount = balanceAmount ?? availableAmount ?? 0
                    state.amount = availableAmount ?? 0
                    state.status = APIStatus.RESOLVED
                } else {
                    state.actualAmount = 0
                    state.amount = 0
                    state.status = APIStatus.REJECTED
                }

                state.apiResult = resultType

                if (fetchChargePointLimitSucceed) {
                    const balanceLimitAmount = chargeLimitByType?.BALANCE?.[0]?.chargeableAmt ?? 0
                    const pgcdLimitAmount = getChargeableAmtByExceptionType(chargeLimitByType?.PGCD, 'MONTHLY_SUM_AMT')
                    const minorLimitAmount = getChargeableAmtByExceptionType(chargeLimitByType?.MINOR, 'SINGLE_AMT')
                    const selectedLimitAmount = adult ? pgcdLimitAmount : minorLimitAmount

                    state.reloadable.amount = balanceLimitAmount
                    state.reloadable.limit = selectedLimitAmount
                    state.reloadable.limitedType =
                        balanceLimitAmount > selectedLimitAmount
                            ? adult
                                ? RechargePointLimitType.MONTH
                                : RechargePointLimitType.MINOR
                            : RechargePointLimitType.BALANCE
                } else {
                    state.reloadable.amount = 0
                }

                state.reloadable.apiResult = chargePointLimitResultType

                if (currMemberType) {
                    state.payMoney.bankCode = currMemberType
                    state.payMoney.bankName = PaymoneyDisplayBankNameMap[currMemberType]
                }
                state.payMoney.userStatus = version
                    ? convertPaymoneyUserStatusType(version)
                    : PayMoneyUserStatus.NOT_OPEN
                state.payMoney.apiResult = memberInfoResultType
                state.payMoney.maskedAccount = account ?? ''

                if (isAMLTarget) {
                    state.maximumHoldingPoint = MAXIMUM_LIMIT_CHARGE_POINT_FOR_RESTRICTED_USER
                }

                state.recharging.processingType = 'DEFERRED'
                state.recharging.expectedAccumulateRate = adminAcmRate + bankbookAcmRate + moneyAcmRate
            })
            /** 포인트 조회 */
            .addCase(getChargePointBalanceBenefit.pending, (state) => {
                state.status = APIStatus.FETCHING
            })
            .addCase(getChargePointBalanceBenefit.fulfilled, (state, {payload}) => {
                const {balanceAmount, availableAmount, resultType} = payload

                state.actualAmount = balanceAmount ?? availableAmount ?? 0
                state.amount = availableAmount ?? 0
                state.status = APIStatus.RESOLVED
                state.apiResult = resultType
            })
            .addCase(getChargePointBalanceBenefit.rejected, (state, {payload}) => {
                const resultType = payload?.resultType ?? PAYMONEY_RESULT_TYPE.FAILED_RETRY_AVAILABLE

                state.actualAmount = 0
                state.amount = 0
                state.status = APIStatus.REJECTED
                state.apiResult = resultType
            })
            /** 페이머니 + 포인트 조회 */
            .addCase(getPaymoneyAndRewardBenefit.pending, (state) => {
                state.status = APIStatus.FETCHING
            })
            .addCase(getPaymoneyAndRewardBenefit.fulfilled, (state, {payload}) => {
                const {
                    paymoney: {availableAmount, balanceAmount, resultType},
                } = payload

                state.actualAmount = balanceAmount ?? availableAmount ?? 0
                state.amount = availableAmount ?? 0
                state.status = APIStatus.RESOLVED
                state.apiResult = resultType
            })
            .addCase(getPaymoneyAndRewardBenefit.rejected, (state, {payload}) => {
                const resultType = payload?.paymoneyResultType ?? PAYMONEY_RESULT_TYPE.FAILED_RETRY_AVAILABLE

                state.actualAmount = 0
                state.amount = 0
                state.status = APIStatus.REJECTED
                state.apiResult = resultType
            })
    },
})

export default slice.reducer
